module.exports = new __parcel__URL__("faq_button_to_open.11769951.webp").toString();